import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const ProductCard = ({ tool, className = "" }) => (
  <article
    data-testid={`product-card-${tool.slug}`}
    className={`group relative flex flex-col gap-5 min-w-0 bg-onix-black2 border border-onix-line p-6 sm:p-7 md:p-9 card-tech ${className}`}
  >
    <div className="flex items-start justify-between gap-4 flex-wrap">
      <span className="tech-label">{tool.num}</span>
    </div>
    <div>
      <h3 className="font-sans font-bold text-sm tracking-[0.12em] uppercase text-onix-white mb-3">{tool.name}</h3>
      <p className="font-serif font-bold text-xl md:text-2xl leading-snug text-onix-white">{tool.title}</p>
    </div>
    <p className="text-sm leading-relaxed text-onix-silver flex-1">{tool.short}</p>
    <Link
      data-testid={`tool-link-${tool.slug}`}
      to={`/herramientas/${tool.slug}`}
      className="inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.14em] text-onix-white mt-2 group/link"
      aria-label={`Ver capacidad: ${tool.name}`}
    >
      <span className="border-b border-onix-line pb-1 transition-colors group-hover/link:border-onix-blue">Ver capacidad</span>
      <ArrowRight size={14} className="transition-transform duration-300 group-hover/link:translate-x-1.5" aria-hidden="true" />
      <span className="absolute inset-0" aria-hidden="true" />
    </Link>
  </article>
);
